'use client';

import { Caption } from '@depop/web-thrift-ui/Typography';
import { useTranslations } from 'next-intl';

import { CampaignBanner } from '../CampaignBanner';
import { ExtendedLink } from '../ExtendedLink';

import styles from './styles.module.css';

import { HELP_ARTICLES } from '@/constants/helpUrls';
import { useIsHomepage } from '@/modules/home/hooks/useIsHomepage';
import { useIsPDP } from '@/modules/product/hooks/useIsPdp';

export function FreeShippingCampaignBanner({
  campaignEndCopy,
}: {
  campaignEndCopy: string;
}) {
  const t = useTranslations('common');
  const isHomepage = useIsHomepage();
  const isProductPage = useIsPDP();

  if (!isHomepage && !isProductPage) {
    return null;
  }

  return (
    <ExtendedLink
      target="_blank"
      rel="noopener noreferrer"
      href={HELP_ARTICLES.FREE_SHIPPING_CAMPAIGN}
    >
      <CampaignBanner className={styles.banner} alwaysVisible>
        <CampaignBanner.Label className={styles.label}>
          {t.rich('FreeShippingBanner.Label', {
            campaignEnd: campaignEndCopy,
            Bold: (chunks) => (
              <Caption variant="sm-bold" as="span" className={styles.boldText}>
                {chunks}
              </Caption>
            ),
            Text: (chunks) => <span>{chunks}</span>,
            Separator: (chunks) => <span>{chunks}</span>,
          })}
        </CampaignBanner.Label>
      </CampaignBanner>
    </ExtendedLink>
  );
}
